/* eslint-disable max-len */
import moment from "moment"
import React from "react"
import { CDN } from "../../../../../config"

export default function BasicDetails({studentDetails}){
    return(
        <div class="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block mt-5" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab" data-te-tab-active>
            <div class="w-[800px] mx-auto">
                <div class="w-full border border-[#e7e7e7] rounded p-4 mb-4">
                    <div class="flex">
                        <div class="w-1/2 pr-4">
                            <div class="flex items-center mb-7">
                                <img src={studentDetails?.image_url !== "" ? `${CDN}${studentDetails?.image_url}`:"/images/photo_uploaded.svg"} alt="img" class="w-[96px] h-[96px] rounded border border-[#e7e7e7]"/>
                                <div class="ml-[24px]">
                                    <p class="text-f7 font-normal text-[#000000]">Student  ID</p>
                                    <p class="text-f7 font-semibold text-[#000000]">{studentDetails?.student_id}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">First Name</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.first_name}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Middle Name</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.middle_name!==""?studentDetails?.middle_name:"-"}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Last Name</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.last_name!==""?studentDetails?.last_name:"-"}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Date of Birth</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{moment(studentDetails?.date_of_birth).format("MMM DD, YYYY")}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Blood Group</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.blood_group}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1">
                                <div class="w-[60%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Gender</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.gender}</p>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 pl-4 border-l border-[#e7e7e7] mt-10 pt-1">
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Date of Admission</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{moment(studentDetails?.date_of_admission).format("MMM DD, YYYY")}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Nationality</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.nationality}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Economic Status</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.economic_status}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Religion</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.religion}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Caste</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.caste}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Caste Category</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.caste_category}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Aadhaar No.</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.aadhar_number?.number!==""?studentDetails?.aadhar_number?.number:"-"}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1">
                                <div class="w-[90%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Register No.</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.registration_number!==""?studentDetails?.registration_number:"-"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}